/**
 * Carte « Reprendre où j'en étais » (refonte Home — L7). Consomme getResumeTarget.
 *
 * Elle désigne LE point de reprise, par ordre de continuité : phase de parcours en cours,
 * puis duel où c'est ton tour, puis dernière session. C'est la seule chose de l'accueil qui
 * dise PAR QUOI COMMENCER — les autres blocs présentent des possibilités côte à côte.
 *
 * ── L'anti-doublon a été retiré le 16/09/2026 ────────────────────────────────
 * La carte se masquait quand la cible de reprise coïncidait avec « Ta priorité de la
 * semaine », pour ne pas afficher deux boutons identiques. Cette bannière (`WeeklyPriorityBanner`)
 * a été fusionnée dans le bloc des quêtes en juillet puis supprimée : la condition ne protégeait
 * plus de rien et masquait la carte sans que rien ne prenne le relais.
 */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Play } from "lucide-react";
import { resumeApi, type ResumeTarget } from "../lib/api";
import { Button } from "./ui/button";

export function ResumeCard({ onNavigate }: { onNavigate?: (page: string) => void }) {
  const { t } = useTranslation();
  const [resume, setResume] = useState<ResumeTarget | null>(null);

  useEffect(() => {
    resumeApi.getMine().then(setResume).catch(() => setResume(null));
  }, []);

  if (!resume) return null;

  return (
    <div className="flex items-center justify-between gap-3 rounded-2xl border bg-white p-4 shadow-[var(--elev-1)]">
      <div className="min-w-0">
        <div className="text-xs font-semibold" style={{ color: "#2C6C9E" }}>{t("resume.eyebrow")}</div>
        <div className="truncate font-semibold" style={{ color: "#384872" }}>{resume.label}</div>
      </div>
      <Button onClick={() => onNavigate?.(resume.navTarget)} className="shrink-0" style={{ backgroundColor: "#2C6C9E" }}>
        <Play className="mr-1.5 h-4 w-4" fill="white" />{t("resume.cta")}
      </Button>
    </div>
  );
}
